import React, { useEffect } from 'react';

const ApprovalEditorsByArticleCategory = ( { datasets } ) => {

  useEffect(() => {
    $("#approval-categories-table").DataTable({
      dom: '<"row"<"large-4 columns"l><"large-6 columns"f>>t<"row"<"large-8 columns"i><"pull-right"p>>',
    });
  }, [])

  useEffect(() => {
    populateTable()
  })
  
  function populateTable() {
    var dt = $("#approval-categories-table").DataTable();
    dt.api().clear();
    for (var i = 0; i < datasets.length; i++) {
      var data = datasets[i];
      dt.fnAddData( [
          data.name,
          data.count
      ], false)
    }
    dt.fnDraw()
  }

  return (
    <table className="table-wrapper data-table" id="approval-categories-table">
      <thead>
        <tr>
          <th>Article Category</th>
          <th>Approval Editors</th>
        </tr>
      </thead>
      <tbody></tbody>
    </table>
  )
}

export default ApprovalEditorsByArticleCategory;